import {Component, Input, OnInit} from '@angular/core';
import {options_menu} from '../../providers/data';
import {Router} from '@angular/router';
import {Auth} from '../../providers/auth';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: []
})
export class HeaderComponent implements OnInit {

  name: string;
  options = options_menu;
  click = false;
  user;
  isNoesys = false;
  isAdmin = false;

  @Input('active') active;
  @Input('circuito') circuito: any = '';

  constructor(private router: Router, private auth: Auth) {
    if (localStorage.getItem('isNoesys') === '1') {
      this.isNoesys = true;
    }
  }

  ngOnInit() {
    // Solo el rol Admin (1) ve las opciones administrativas (p. ej. SETTINGS).
    // El mantenedor (rol 2) conserva el resto del menú.
    // Guard: system/maintainer nunca visible en header (obscurity, T11) — data.ts no expone, filtro defensivo por si se añade
    this.isAdmin = !!(this.auth.user && this.auth.user.roleId === 1);
    if (!this.isAdmin) {
      this.options = options_menu.filter(o => !o.adminOnly);
    }
    // defensivo: aunque options_menu no contiene maintainer, filtrar cualquier url con system/maintainer
    this.options = this.options.filter(function(o) { return o.url.indexOf('maintainer') === -1 && o.url.indexOf('system') === -1; });
  }

  goView(path) {
    this.router.navigateByUrl(path, {skipLocationChange: true}).then(() => {
    });
  }

  logout() {
    this.auth.userCheck(() => {
      this.auth.logout();
    }, () => {
      this.router.navigate(['login']);
    });

  }

}





// WEBPACK FOOTER //
// ./src/app/admin/header/header.component.ts